// S8 Register an app (M11). Staff with app.register: every Editor and Admin (poc CT-008).
import { createFileRoute } from '@tanstack/react-router';
import { ErrorState } from '@/components/ErrorState';
import { RegisterWizard } from '@/features/admin/apps/RegisterWizard';
import { ApiError } from '@/lib/api';
import { canTool, requireStaffSession, useSession } from '@/lib/session';

export const Route = createFileRoute('/apps/new')({
  beforeLoad: ({ context, location }) => requireStaffSession(context.queryClient, location.href),
  component: RegisterAppPage,
});

function RegisterAppPage() {
  const session = useSession();
  if (!canTool(session, 'app.register')) {
    return (
      <ErrorState
        error={
          new ApiError(403, {
            code: 'forbidden',
            detail: 'Only Editors and Admins register apps.',
          })
        }
      />
    );
  }
  return <RegisterWizard />;
}
